import authenticationSagas from './root/sagas';

export default [...authenticationSagas];
